import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

//import SingleChoiceFilter from 'modules/core/components/Filter/filters/SingleChoice'
import i18n from 'modules/core/lib/i18n'

import SearchBar from 'modules/people_chart/components/ActionBar/SearchBar'

import { SearchItem } from './SearchBar/SearchBarItem'

interface Props {
  canEdit: boolean
  editing: boolean
  disabled?: boolean
  onEditingToggle: () => void
  onSearchSelection: (item: SearchItem, teamIds: string[]) => void
}

const ActionBar: React.FC<Props> = ({
  canEdit,
  editing,
  disabled = false,
  onEditingToggle,
  onSearchSelection,
}) => {
  //const [value, setValue] = React.useState<string | undefined>('collapsed-view')

  return (
    <Box>
      <Box padding="s24" gap="s16" flexDirection="row" alignItems="center">
        <SearchBar disabled={disabled} onSelection={onSearchSelection} />
        {/* <Box>
          <SingleChoiceFilter
            label={'Display'} */}
        {/* options={[
              {
                label: 'Teams',
                value: 'collapsed-view',
              },
              {
                label: 'Employees',
                value: 'expanded-view',
              },
            ]} */}
        {/* value={value}
            onValueChange={setValue}
          /> */}
        {/* </Box> */}
        {canEdit && (
          <Box>
            <Button
              iconName={editing ? false : 'pencil'}
              disabled={disabled}
              onClick={onEditingToggle}
            >
              {editing
                ? i18n.t('people_chart.action_bar.finish_editing')
                : i18n.t('people_chart.action_bar.edit_chart')}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default ActionBar
